module.exports = __webpack_public_path__ + "static/media/Boat.567dfa05.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/png-images/Boat.png
// module id = 3030
// module chunks = 0